import { createSlice } from "@reduxjs/toolkit";

const initialState = { data: { details: [], allQuestions: [], selectedDetails: [], skipModal: null }, };

const onboardingDetailSlice = createSlice({
    name: "onboardingDetails",
    initialState,
    reducers: {
        setSkipModalData: (state, { payload }) => {
            state.data.skipModal = payload;
        }
    },
});

export const { setSkipModalData } = onboardingDetailSlice.actions;
export default onboardingDetailSlice;